import Cookies from 'js-cookie';

const COOKIE_KEY = 'DEV_ENVIRONMENT';
export const DEV_ENVIRONMENTS = [
    {
        name: 'PRODUCTION',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-pro01.forcemanager.com',
            NEW_API_URL: 'https://be-services.forcemanager.net/api',
            API_URL: 'https://proxy-pro.forcemanager.com',
            B2_URL: 'https://be-pro.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyCPAkvsFL1NBHJnuHrO23YzpJDSCVBZYdw',
        },
    },
    {
        name: 'PREPRODUCTION',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-pre.forcemanager.com',
            NEW_API_URL: 'https://be-servicespre.forcemanager.net/api',
            API_URL: 'https://proxy-pre.forcemanager.com',
            B2_URL: 'https://be-pre.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence-pre.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyDI7JCJSoTHZWvqha1Y7fIXSwAMiO6UMlI',
        },
    },
    {
        name: 'STAGING',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-sta.forcemanager.com',
            NEW_API_URL: 'https://be-servicessta.forcemanager.net/api',
            API_URL: 'https://proxy-sta.forcemanager.com',
            B2_URL: 'https://be-sta.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence-sta.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyDI7JCJSoTHZWvqha1Y7fIXSwAMiO6UMlI',
        },
    },
    {
        name: 'LOCAL',
        config: {
            S200UKI_CONNECTOR_BASE_URL: 'https://connectors-pre.forcemanager.com',
            NEW_API_URL: 'https://be-servicespre.forcemanager.net/api',
            API_URL: 'http://localhost:8080',
            B2_URL: 'https://be-pre.forcemanager.net',
            FORCE_BI_URL: 'https://fmbusinessintelligence-pre.forcemanager.net/api',
            GOOGLE_MAPS_API_KEY: 'AIzaSyDI7JCJSoTHZWvqha1Y7fIXSwAMiO6UMlI',
        },
    },
];

export const loadDevEnvironment = (key) => {
    const configKey = key || Cookies.get(COOKIE_KEY) || 'PREPRODUCTION';
    window.FM_CONFIG = {
        ...(window.FM_CONFIG || {}),
        ...(DEV_ENVIRONMENTS.find((item) => configKey === item.name)?.config || {}),
    };
};

export const getDevEnvironment = () => {
    return Cookies.get(COOKIE_KEY);
};

export const setDevEnvironment = (key = '') => {
    Cookies.set(COOKIE_KEY, key);
};
